import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'defaultVal', pure:true })
export class DefaultValuePipe implements PipeTransform {
    transform(value: any, defValue: any): any {
        return value == undefined ? defValue : value;
    }
}